import { NgModule, isDevMode, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgZorroAntdModule } from '@public-page/ng-zorro-antd/ng-zorro-antd.module';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NZ_I18N, NZ_DATE_CONFIG } from 'ng-zorro-antd/i18n';
import * as Sentry from '@sentry/angular-ivy';

// Custom modules
import { CoreModule } from '@modules/core/core.module';
import { SharedModule } from '@modules/shared/shared.module';
import { AuthorizationModule } from '@modules/authorization/authorization.module';
import { AppRoutingModule } from '@public-page/app-routing.module';
import { AllowedCookiesModule } from '@modules/allowed-cookies/allowed-cookies.module';

// Components
import { RootComponent } from '@public-page/components';

// Store
import { effects, reducer } from '@public-page/store';

// Utils
import { translateLoaderFactory, i18nAntFactory } from '@modules/core/utils';
import { Router } from '@angular/router';

@NgModule({
  declarations: [RootComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    CoreModule,
    SharedModule,
    AuthorizationModule,
    AllowedCookiesModule,
    StoreModule.forRoot(reducer),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: !isDevMode(),
    }),
    EffectsModule.forRoot([...effects]),
    AppRoutingModule,
    StoreRouterConnectingModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
        console.log('APP_INITIALIZER');
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: NZ_I18N,
      useFactory: i18nAntFactory,
      deps: [TranslateService],
    },
    {
      provide: NZ_DATE_CONFIG,
      useValue: {
        firstDayOfWeek: 1,
      },
    },
  ],
  bootstrap: [RootComponent],
})
export class AppModule {}
